import React from "react";
import { ECartesianAxis } from "../../../Model/Axis";
import { CartesianCoordinate } from "../../../Model/Coordinate";

type CoordinateViewProps = {
  axis: ECartesianAxis;
  position: number;
};

export function CoordinateViewTextBox({ axis, position }: CoordinateViewProps) {
  return (
    <div
      style={{
        display: "flex",
        fontSize: "14px",
        alignItems: "center",
        marginLeft: 7,
        marginRight: 7,
      }}
    >
      <div>{ECartesianAxis[axis]}:</div>
      <div
        style={{
          height: 24,
          // width: 54,
          width: "3vw",
          border: "1px solid #CCCCCC",
          marginLeft: 3,
          marginRight: 5,
          color: "#E88C40",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px 10px 0px 8px",
        }}
      >
        {position.toFixed(2)}
      </div>
      <div>mm</div>
    </div>
  );
}

type Props = {
  style?: React.CSSProperties;
  position: CartesianCoordinate;
};

export default function WellControlValueLabels({ style, position }: Props) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        boxSizing: "border-box",
        ...style,
      }}
    >
      <CoordinateViewTextBox axis={ECartesianAxis.X} position={position.x} />
      <CoordinateViewTextBox axis={ECartesianAxis.Y} position={position.y} />
      <CoordinateViewTextBox axis={ECartesianAxis.Z} position={position.z} />
    </div>
  );
}
